module.exports = __webpack_public_path__ + "static/media/15_CAP.6c0129ed.png";